// Import token extractor to run before Angular bootstraps
// This ensures the token is removed from URL immediately
import './app/utils/token-extractor';

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
